// Api
import * as Api from "office/reports/leads/api";
import DateHelper from "common/utils/DateHelper";
//-------------------------------------------------------------------------------------------------------------------------------
export const LOAD = "REPORT_OFFICE_LEADS_STATS";
export const FETCHING = "REPORT_OFFICE_FETCHING_LEADS_STATS";
export function fetchingData(officeId, fromDate, toDate) {
    return {
        type: FETCHING,
        officeId: officeId,
        fromDate: fromDate,
        toDate: toDate
    };
}
export function recievedData(report) {
    return {
        type: LOAD,
        report: report
    };
}
//-------------------------------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------------------------------
export const getIfNeeded = (officeId, report) => {
    return (dispatch) => {
        if (report === null || report.officeId != officeId) {
            getLeads(dispatch, officeId, null, null, true);
        }
    };
};
//-------------------------------------------------------------------------------------------------------------------------------
export const getForced = (officeId, startDate, endDate, pageRequest = true) => {
    return (dispatch) => {
        getLeads(dispatch, officeId, startDate, endDate, pageRequest);
    };
};
//-------------------------------------------------------------------------------------------------------------------------------
const getLeads = (dispatch, officeId, fromDate, toDate, pageRequest = true) => {
    // Default date range for report
    if (!fromDate || !toDate) {
        let defaultRange = DateHelper.getLast7Days();
        fromDate = defaultRange[0];
        toDate = defaultRange[1];
    }
    // Dispatch that we are fetching the report
    dispatch(fetchingData(officeId, fromDate, toDate));
    // Fetch
    Api.async_leadsRequest(dispatch, officeId, fromDate, toDate, pageRequest)
        .then((report) => {
        dispatch(recievedData(report));
    }, (message) => {
        //notifier.notifyError("Error Generating Report", message);
        dispatch(recievedData({
            isFetching: false,
            officeId: officeId,
            officeName: "",
            startDate: fromDate,
            endDate: toDate,
            items: []
        }));
    });
};
//-------------------------------------------------------------------------------------------------------------------------------
